const ARRIVAL_EXPERIENCE_ROOT = "/packages/experiences/system/arrival";
const LEGACY_AUTH_EXPERIENCE_ROOT = "/packages/experiences/system/auth";

export const ARRIVAL_STYLE_STORAGE_KEY = "worksuiteArrivalStyle";
export const DEFAULT_ARRIVAL_STYLE = "immersive-center";

export const ARRIVAL_STYLES = Object.freeze({
  default: Object.freeze({ id: "default", label: "Default", presentation: "floating-card" }),
  "immersive-center": Object.freeze({ id: "immersive-center", label: "Immersive Center", presentation: "immersive-center" }),
});

const normalizeStyleId = (styleId) => ARRIVAL_STYLES[styleId] ? styleId : DEFAULT_ARRIVAL_STYLE;
const createAssetCandidates = (sceneId, styleId, viewport) => [
  `${ARRIVAL_EXPERIENCE_ROOT}/${sceneId}/${styleId}/${viewport}.webp`,
  `${ARRIVAL_EXPERIENCE_ROOT}/${sceneId}/${viewport}.webp`,
  `${LEGACY_AUTH_EXPERIENCE_ROOT}/${sceneId}/${viewport}.webp`,
];

const SCENE_DEFAULTS = Object.freeze({
  login: Object.freeze({
    ariaLabel: "Worksuite Campaigns arrival and sign-in experience",
    entranceTitle: "Welcome to Campaigns",
    entranceSubtitle: "Continue into your working environment.",
    entranceActionLabel: "Enter Campaigns",
  }),
  signup: Object.freeze({
    ariaLabel: "Worksuite Campaigns arrival and signup experience",
    entranceTitle: "Begin with Campaigns",
    entranceSubtitle: "Continue into your working environment.",
    entranceActionLabel: "Enter Campaigns",
  }),
});

export function getArrivalStyle(styleId) { return ARRIVAL_STYLES[normalizeStyleId(styleId)]; }
export function getArrivalExperience(sceneId = "login", styleId = DEFAULT_ARRIVAL_STYLE) {
  const normalizedSceneId = SCENE_DEFAULTS[sceneId] ? sceneId : "login";
  const normalizedStyleId = normalizeStyleId(styleId);
  return {
    id: normalizedSceneId,
    styleId: normalizedStyleId,
    style: ARRIVAL_STYLES[normalizedStyleId],
    position: "center center",
    panelAlign: "right",
    desktopCandidates: createAssetCandidates(normalizedSceneId, normalizedStyleId, "desktop"),
    mobileCandidates: createAssetCandidates(normalizedSceneId, normalizedStyleId, "mobile"),
    ...SCENE_DEFAULTS[normalizedSceneId],
  };
}
export function readArrivalStyleFromLocation() {
  if (typeof window === "undefined") return DEFAULT_ARRIVAL_STYLE;
  const requestedStyle = new URLSearchParams(window.location.search).get("arrivalStyle");
  if (requestedStyle && ARRIVAL_STYLES[requestedStyle]) {
    try { window.localStorage.setItem(ARRIVAL_STYLE_STORAGE_KEY, requestedStyle); } catch (_) {}
    return requestedStyle;
  }
  try { return normalizeStyleId(window.localStorage.getItem(ARRIVAL_STYLE_STORAGE_KEY)); }
  catch (_) { return DEFAULT_ARRIVAL_STYLE; }
}
